import api from '../../../api/client';
import React, { useState, useRef } from "react";
import { Modal, Form, Input, Button, Space, message, Row, Col, Typography } from "antd";
import axios from "axios";
import config from "../../../config";
import PayrollPeriodSelect from "./PayrollPeriodSelect";

const { Text } = Typography;

const SalaryCalculator = ({ visible, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const environment = window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;

  const handleSubmit = async (values) => {
    if (!selectedPeriod) {
      message.warning("Please select a period");
      return;
    }

    setLoading(true);
    try {
      const requestData = {
        period: selectedPeriod,
        otherDeductions: values.otherDeductions || 0,
      };
      const { data } = await api.post(`/hr/payroll/generate`, requestData);
      message.success(data.message || "Payroll generated successfully");
      form.resetFields();
      setSelectedPeriod(null);
      onCancel();
      onSuccess();
    } catch (err) {
      message.error(err.response?.data?.message || "Failed to generate payroll");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Generate Payroll"
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={500}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item label="Select Period" required>
          <PayrollPeriodSelect selectedPeriod={selectedPeriod} setSelectedPeriod={setSelectedPeriod} />
        </Form.Item>

        {/* <Form.Item name="otherDeductions" label="Other Deduction">
          <Input type="number" min={0} step={0.01} placeholder="Enter additional deductions" />
        </Form.Item> */}

        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit" loading={loading}>
              Generate Payroll
            </Button>
            <Button onClick={onCancel}>Cancel</Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SalaryCalculator;